const categoryList = {
    // Must define category as below format and space is not allowed in category name
    GenAI : "Gen AI",
    Liferay : "Liferay",
    NextJS : "NextJS",
    FutureTrends : "Future Trends",
    TechTutorials : "Tech Tutorials",
    // Shopify : "Shopify",
    // EcommorceSolutions : "E Commerce Solutions",
    // CMSSolutions : "CMS Solutions",
  };
  
  export default categoryList;
  